import { render } from "./Sale_Profile.vue?vue&type=template&id=8ed4b724&scoped=true"
import script from "./Sale_Profile.vue?vue&type=script&lang=js"
export * from "./Sale_Profile.vue?vue&type=script&lang=js"

import "./Sale_Profile.vue?vue&type=style&index=0&id=8ed4b724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed4b724"]])

export default __exports__